/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Flex,
  message,
  Badge,
  Card,
  Select,
  Modal,
  InputNumber,
} from "antd";
import { Row, Col, Space, Upload } from "antd";
import { SaveFilled } from "@ant-design/icons";
import { ButtonBack, uploadButton } from "../../components/button";
import { SearchOutlined } from "@ant-design/icons";
import { Items } from "./model";
import { useLocation, useNavigate } from "react-router";
import { delay, BACKEND_URL_MAIN } from "../../utils/util";
import Swal from "sweetalert2";
// import OptionService from '../../service/Options.service';
import Itemservice from "../../service/Items.Service";
import OptionService from "../../service/Options.service";
import ModalSupplier from "../../components/modal/supplier/ModalSupplier";
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const itemservice = Itemservice();
const opService = OptionService();
const from = "/items";

const ItemsManage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const [form] = Form.useForm();
  // const [formImage] = Form.useForm();
  const [formDetail, setFormDetail] = useState(Items);
  const [optionUnit, setOptionUnit] = useState([]);
  const [optionType, setOptionType] = useState([]);
  const [optionsBrand, setOptionBrand] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("");
  const [openSupplier, setOpenSupplier] = useState(false);
  useEffect(() => {
    // setLoading(true);
    GetItemsUnit();
    GetItemsType();
    GetBrand();
    if (config?.action !== "create") {
      getsupData(config.code);
    }
    // console.log(config);

    return () => {
      form.resetFields();
    };
  }, []);

  const GetItemsType = () => {
    opService.optionsItemstype().then((res) => {
      let { data } = res.data;
      setOptionType(data);
    });
  };

  const GetBrand = () => {
    opService.optionsBrand().then((res) => {
      let { data } = res.data;
      setOptionBrand(data);
    });
  };

  const GetItemsUnit = () => {
    opService.optionsUnit().then((res) => {
      let { data } = res.data;
      setOptionUnit(data);
    });
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const getsupData = (v) => {
    itemservice
      .get(v)
      .then(async (res) => {
        const { data, file } = res.data;

        const init = {
          ...data,
        };

        setFormDetail(init);
        form.setFieldsValue({ ...init });

        let fileurl = file.map((data) => ({
          ...data,
          file_name: `${BACKEND_URL_MAIN}/uploads/` + data.file_name,
        }));
        // console.log(fileurl) ;
        const formattedFileList = fileurl.map((data) => ({
          img_id: data.img_id,
          uid: data.uid,
          name: data.name,
          status: "done",
          url: data.file_name,
        }));
        setFileList(formattedFileList);
        form.setFieldsValue({ prod_img: formattedFileList });
      })
      .catch((err) => {
        console.log(err);
        message.error("Error getting infomation Product.");
      });
  };

  const handleConfirm = () => {
    form.validateFields().then((v) => {
      const source = { ...formDetail, ...v };
      const actions =
        config?.action !== "create"
          ? itemservice.update(source)
          : itemservice.create(source);

      actions
        .then(async (r) => {
          message.success("Request success.");
          navigate(from, { replace: true });
          await delay(300);
          console.clear();
        })
        .catch((err) => {
          console.warn(err);
          const data = err?.response?.data;
          message.error(data?.message || "บันทึกไม่สำเร็จ");
        });
    });
  };

  const handlePreview = async (file) => {
    // console.log(file)
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };
  const handleCancel = () => setPreviewOpen(false);

  const onRemove = (file) => {
    // console.log(file);
    //debugger
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const formData_Del = new FormData();
          formData_Del.append("img_id", file.img_id);
          formData_Del.append("file", file);
          formData_Del.append("uid", file.uid);

          const actions =
            config?.action !== "create"
              ? itemservice.deletePicUpdate(formData_Del)
              : itemservice.deletePic(formData_Del);

          actions.then(async (res) => {
            //debugger
            let { status, data } = res;
            if (status === 200 && data.status === "1") {
              handleRemove(file);
            } else {
              // alert(data.message)
            }
          });
        } catch (error) {
          message.error("Failed to delete file");
        }
      }
    });

    // console.log(fileList);
  };

  const onUploadSuccess = (file) => {
    //debugger
    // alert(`${BACKEND_URL_MAIN}/uploads/` + file.uid + "_" + file.name);
    const newFile = {
      uid: file.uid,
      name: file.name,
      status: "done",
      url: `${BACKEND_URL_MAIN}/uploads/` + file.uid + "_" + file.name,
    };
    setFileList((prevFileList) => [...prevFileList, newFile]);
    // console.log(file);
    // console.log('-----');
    // console.log(fileList);
  };

  // const handleChange = (info) => {
  //   console.log('FileList:', info.fileList);
  //   //setFileList(info.fileList);
  // };

  const handleRemove = (file) => {
    //debugger
    // Your logic to remove the file
    const newFileList = fileList.filter((f) => f.uid !== file.uid);
    setFileList(newFileList);
    //message.success(`File deleted successfully`);
  };
  const handleChoosedSupplier = (val) => {
    // console.log(val)
    const fvalue = form.getFieldsValue();
    const addr = [
      !!val?.idno ? `${val.idno} ` : "",
      !!val?.road ? `${val?.road} ` : "",
      !!val?.subdistrict ? `${val.subdistrict} ` : "",
      !!val?.district ? `${val.district} ` : "",
      !!val?.province ? `${val.province} ` : "",
      !!val?.zipcode ? `${val.zipcode} ` : "",
      !!val?.country ? `(${val.country})` : "",
    ];
    const supplier = {
      ...val,
      address: addr.join(""),
      contact: val.contact,
      tel: val?.tel?.replace(/[^(0-9, \-, \s, \\,)]/g, "")?.trim(),
    };
    // console.log(val.contact)
    setFormDetail((state) => ({ ...state, ...supplier }));
    form.setFieldsValue({ ...fvalue, ...supplier });
  };
  const propsAdd = {
    customRequest: async ({ file, onSuccess, onError }) => {
      if (
        form.getFieldValue("stcode") !== "" &&
        form.getFieldValue("stcode") !== undefined
      ) {
        // console.log(fileList);
        const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif"]; // รายการสกุลไฟล์ที่อนุญาต
        const fileExtension = file.name.slice(
          ((file.name.lastIndexOf(".") - 1) >>> 0) + 2
        ); // สกุลไฟล์ของไฟล์ที่อัพโหลด
        if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`)) {
          message.error("สกุลไฟล์ไม่ถูกต้อง");
          onError();
          return false;
        } else {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("uid", file.uid);
          formData.append("stcode", form.getFieldValue("stcode"));
          // console.log(file)
          try {
            itemservice.uploadPic(formData).then(async (res) => {
              //debugger
              let { status, data } = res;
              if (status === 200 && data.status === "1") {
                onUploadSuccess(file);
                onSuccess();
                message.success(`${file.name} file uploaded successfully`);
              } else {
                // alert(data.message)
              }
            });
          } catch (error) {
            onError(error);
            message.error(`${file.name} file upload failed.`);
          }
        }
        // console.log(fileList);
      } else message.error(`กรุณากรอกรหัสสินค้าก่อน.`);
    },
  };

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item
            label="รหัสสินค้า"
            value=" "
            name="stcode"
            rules={[{ required: true, message: "โปรดกรอกข้อมูล" }]}
          >
            <Input
              disabled={config.action === "edit"}
              placeholder="กรอกรหัสสินค้า"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
          <Form.Item
            label="ชื่อสินค้า"
            name="stname"
            rules={[{ required: true, message: "โปรดกรอกข้อมูล" }]}
          >
            <Input placeholder="กรอกชื่อสินค้า" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
          <Form.Item label="ชื่อสินค้า EN" name="stnameEN">
            <Input placeholder="กรอกชื่อสินค้า" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item label="หน่วยสินค้า" name="unit">
            <Select
              size="large"
              showSearch
              filterOption={filterOption}
              placeholder="เลือกหน่วยสินค้า"
              options={optionUnit.map((item) => ({
                value: item.value,
                label: item.value,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item label="ประเภทสินค้า" name="typecode">
            <Select
              size="large"
              showSearch
              filterOption={filterOption}
              placeholder="เลือกประเภทสินค้า"
              options={optionType.map((item) => ({
                value: item.typecode,
                label: item.typename,
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item label="ยี่ห้อสินค้า" name="brand_code">
            <Select
              size="large"
              showSearch
              filterOption={filterOption}
              placeholder="เลือกยี่ห้อสินค้า"
              options={optionsBrand.map((item) => ({
                value: item.brand_code,
                label: item.brand_name,
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item label="ราคาขายปลีก" name="price">
            <Input placeholder="กรอกราคาขายปลีก" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item label="ราคาขายส่ง" name="wholesale_price">
            <Input placeholder="กรอกราคาขายส่ง" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item label="ราคาซื้อ" name="buyprice">
            <Input placeholder="กรอกราคาซื้อ" />
          </Form.Item>
        </Col>        
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item label="ราคาสมาชิก" name="member_price">
            <Input placeholder="กรอกราคาสมาชิก" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">        
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item label="สต๊อกขั้นต่ำ" name="min">
            <InputNumber
              style={{
                width: "100%",
              }}
              size="large"
              placeholder="กรอกสต๊อกขั้นต่ำ"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={4}>
          <Form.Item label="สต๊อกสูงสุด" name="max">
            <InputNumber
              style={{
                width: "100%",
              }}
              size="large"
              placeholder="กรอกสต๊อกสูงสุด"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8}>
          <Form.Item
            name="supcode"
            htmlFor="supcode-1"
            label="จากผู้ขาย"
            className="!mb-1"
            rules={[{ required: true, message: "Missing Supplier Code" }]}
          >
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="เลือก ผู้ขาย"
                id="supcode-1"
                value={formDetail.supcode}
                className="!bg-white"
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenSupplier(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        </Row>
        <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
            <Form.Item label="ข้อมูลส่วนเสริม สินค้า" name="st_add_on">
              <Input.TextArea placeholder="ข้อมูลส่วนเสริม" rows={3} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={4} lg={4} xl={4}>
            รูปสินค้า
            <Form.Item
              name="prod_img"
              getValueFromEvent={(event) => {
                return event?.fileList;
              }}
              // rules={[
              //   {
              //     required: true,
              //     message: "กรุณาอัพโหลดรูปสินค้า!",
              //   },
              // ]}
            >
              <Upload
                {...propsAdd}
                fileList={fileList}
                listType="picture-card"
                onPreview={handlePreview}
                onRemove={onRemove}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
            </Form.Item>
          </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={4}
          style={
            config.action === "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="สถานการใช้งาน" name="active_status">
            <Select
              size="large"
              options={[
                {
                  value: "Y",
                  label: <Badge status="success" text="เปิดการใช้งาน" />,
                },
                {
                  value: "N",
                  label: <Badge status="error" text="ปิดการใช้งาน" />,
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
          >
            บันทึก
          </Button>
        </Flex>
      </Col>
    </Row>
  );
  return (
    <div className="item-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
      <Space direction="vertical" className="flex gap-2">
        <Form
          form={form}
          name="form_in_modal_add"
          layout="vertical"
          autoComplete="off"
          initialValues={{
            modifier: "public",
          }}
        >
          <Card title={config?.title}>{Detail}</Card>
        </Form>
        {SectionBottom}
      </Space>
      {openSupplier && (
        <ModalSupplier
          show={openSupplier}
          close={() => setOpenSupplier(false)}
          values={(v) => {
            handleChoosedSupplier(v);
          }}
        ></ModalSupplier>
      )}
    </div>
  );
};

export default ItemsManage;
